import React, { useEffect } from 'react'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import useTheme from '@material-ui/core/styles/useTheme'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Box from '@material-ui/core/Box'
import { isFalsyOrEmpty } from '../helpers/object';

export const TicketCancelled = ({ticket, cancelTicketCallback, timeouttext, throwtickettext, showticketnumber, dynamicheading, dynamicfooter}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  useEffect(() => {
    localStorage.removeItem("selectedqueuename");
  },[])

  const TopText = () => {
    if (isFalsyOrEmpty(dynamicheading))
      return <span/>
    else 
      return (
        <Typography
          align="center"
          variant="h3"
          className={"ticket-toptext"}
          id={"ticket-waiting-toptext"}
        >
          { dynamicheading }
        </Typography>
      )
  }

  const BottomText = () => {
    if (isFalsyOrEmpty(dynamicfooter))
      return <span/>
    else
      return (
        <Typography
          align="center"
          variant="h3"
          className={"ticket-bottomtext"}
          id={"ticket-waiting-bottomtext"}
        >
          { dynamicfooter }
        </Typography>
      )
  }

  const finishService = () => {
    window.location.replace('https://www.masmovilpanama.com/')
  }

  return  (
    <Box className={classes.wrapper} >
      <Paper elevation={0} className={classes.container}>
        { TopText() }
        {
          showticketnumber ?
          <Paper elevation={0} className={[classes.semicontainer, "ticket-semicontainers"].join(' ')} id="ticket-cancelled-semicontainer-1">
            <Typography 
                align="center" 
                variant="h6"
                className={[classes.title, "ticket-titles"].join(' ')}
                id="ticket-called-text-id"
            >
            { timeouttext || "Din tid är ute"}
            </Typography>
           <Typography
              align="center"
              variant="h1"
              className={[classes.valuetext, "ticket-valuetexts"].join(' ')}
              id="ticket-cancelled-valuetext-id"
            >
              { ticket.ticketnumber}
            </Typography>
          </Paper>
          :
          <span/>
        }
        <Typography
            align="center"
            variant="h3"
            className={[classes.timestamptext, "ticket-timestamp-texts"].join(' ')}
            id="ticket-cancelled-timestamp-text-id"
        >
          { ticket.timestamp }
        </Typography>
        { BottomText() }
        <div className={classes.buttonwrapper} id="ticket-finish-button-wrapper-id">
          <Button variant="contained" className={[classes.button, "buttons", "secondary-buttons"].join(' ')} onClick={() => { finishService() }}>
            { <Typography className="secondary-buttons-texts" id="ticket-finish-button-text">{throwtickettext || ""}</Typography>}
          </Button>
        </div>
      </Paper>
    </Box>
  )
}

const useStyles = makeStyles({
  container: theme => ({
    backgroundColor: theme.palette.background.main,
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    position: 'relative',
    alignItems: 'center',
    overflow: 'auto'
  }),
  wrapper: {
    display: 'flex', 
    flexDirection: 'column', 
    height: '100%',
    overflow: 'auto'
  },
  semicontainer: theme => ({
    minWidth: '300px',
    maxWidth: '80%',
    borderRadius: '20px',
    backgroundColor: theme.palette.ticket_cancelled.main,
    margin: '0.5rem 0',
    padding: '0 0.5rem 0.5rem 0.5rem'
  }),
  title: theme => ({
    color: theme.palette.info.main,
    marginTop: '0.5rem'
  }),
  valuetext: theme => ({
    color: theme.palette.info.main,
    fontSize: '4rem',
    fontWeight: '900',
    [theme.breakpoints.down('xs')]: {
      fontSize: '3rem' 
     }
  }),
  timestamptext: theme => ({
    color: theme.palette.secondary_text.main,
    fontSize: 'small'
  }),
  button: theme => ({
    backgroundColor: theme.palette.info.main,
    color: theme.palette.button_text.main,
    borderRadius: 0,
    [theme.breakpoints.up('lg')]: {
      '&:hover': {
        backgroundColor: 'black',
        color: 'white'
      }
    },
    [theme.breakpoints.down('lg')]: {
      '&:hover': {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.button_text.main
      }
    }
  }),
  buttonwrapper: {
    marginTop: 'auto',
    marginBottom: '0.5rem',
  },

})